import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import AITagGenerationModal from './AITagGenerationModal'

interface AITagGenerationModalState {
  siteId: number
  onRestored: () => void
}

const defaultValue: AITagGenerationModalState = { siteId: 0, onRestored: () => {} }

export const AITagGenerationModalContext =
  createModalContext<AITagGenerationModalState>(defaultValue)

const AITagGenerationModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<AITagGenerationModalState>(defaultValue)
  return (
    <AITagGenerationModalContext.Provider value={state}>
      {children}
      <AITagGenerationModal />
    </AITagGenerationModalContext.Provider>
  )
}

export default AITagGenerationModalProvider
